import Store from 'store/store';

Store.on('TOGGLE_TRAILER_OVERLAY', (open) => {
	if (!Store.get().trailerOverlay) {
		Store.get().set({ trailerOverlay: {} });
	}

	if (typeof open !== 'boolean') {
		open = !Store.get().trailerOverlay.overlayOpen;
	}

	Store.get().trailerOverlay.set({ overlayOpen: open });
	if (open) {
		Store.get().trailerOverlay.set({ overlayTriggered: true });
	}

	Store.emit(open ? 'ENABLE_SCROLLING_LOCK' : 'DISABLE_SCROLLING_LOCK');

	if (open) {
		Store.emit('SET_HEADER_ACTION', {
			icon: 'close',
			action: () => Store.emit('TOGGLE_TRAILER_OVERLAY', false),
			tag: 'closeTrailerOverlay'
		});
	} else {
		Store.emit('REMOVE_HEADER_ACTIONS', 'closeTrailerOverlay');
	}
});
